import React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {QuestionMarkMajorMonotone, LogOutMinor} from '@shopify/polaris-icons';
import {Popover, ActionList, Avatar} from '@shopify/polaris';
import withAuth from 'sections/services-marketplace/experts/sections/with-auth/withAuth';
import {GetShopAuthQueryData} from 'sections/services-marketplace/experts/sections/with-auth/graphql/GetShopAuth.graphql';
import {Routes} from '../../utilities';

import styles from './UserMenu.scss';

interface OwnProps {
  currentShop: GetShopAuthQueryData.CurrentShop | null;
  currentShopUser: GetShopAuthQueryData.CurrentShopUser | null;
}

type CombinedProps = WithI18nProps & OwnProps;

interface State {
  active: boolean;
}

class UserMenu extends React.Component<CombinedProps, State> {
  state: State = {
    active: false,
  };

  togglePopover = () => {
    this.setState(({active}) => {
      return {active: !active};
    });
  };

  visitLink = (link: string) => {
    return () => {
      window.location.assign(link);
    };
  };

  merchantInitials = (): string => {
    const {currentShopUser} = this.props;

    return currentShopUser
      ? `${currentShopUser.firstName.substr(
          0,
          1
        )}${currentShopUser.lastName.substr(0, 1)}`
      : '';
  };

  render() {
    const {currentShop, currentShopUser, i18n} = this.props;

    if (!currentShop || !currentShopUser) return null;

    const activatorContentMarkup = (
      <div className={styles.ActivatorWrapper}>
        <button
          type="button"
          className={styles.Activator}
          onClick={this.togglePopover}
        >
          <Avatar initials={this.merchantInitials()} size="small" />
          <span className={styles.Details}>
            <p className={styles.Name}>
              {currentShopUser.firstName} {currentShopUser.lastName}
            </p>
            <p className={styles.Detail}>{currentShop.name}</p>
          </span>
        </button>
      </div>
    );

    const sections = [
      {
        items: [
          {
            content: i18n.translate('Global.Header.navigation.buttonCta'),
            onAction: this.visitLink(
              Routes.workflowPath(currentShop.permanentDomain)
            ),
          },
          {
            content: i18n.translate('Global.Header.navigation.jobs'),
            onAction: this.visitLink(
              Routes.jobsPath(currentShop.permanentDomain)
            ),
          },
          {
            content: i18n.translate('Global.Header.navigation.invoices'),
            onAction: this.visitLink(
              Routes.invoicesPath(currentShop.permanentDomain)
            ),
          },
        ],
      },
      {
        items: [
          {
            content: i18n.translate('Global.Header.navigation.help'),
            onAction: this.visitLink(Routes.helpUrl()),
            icon: QuestionMarkMajorMonotone,
          },
          {
            content: i18n.translate('Global.Header.navigation.logout'),
            onAction: this.visitLink(Routes.logoutPath),
            icon: LogOutMinor,
          },
        ],
      },
    ];

    return (
      <div className={styles.UserMenu}>
        <Popover
          active={this.state.active}
          activator={activatorContentMarkup}
          onClose={this.togglePopover}
          preferredAlignment="right"
        >
          <div className={styles.ActionListContainer}>
            <ActionList sections={sections} />
          </div>
        </Popover>
      </div>
    );
  }
}

export default withAuth(withI18n()(UserMenu));
